<template>
  <div class="sr-select-people">
    <ul class="people_list">
      <li
        class="people_item"
        v-for="(item, index) in value"
        :key="item[props.value]"
      >
        <!-- <img
          :src="previewUrl + item[props.avatar]"
          class="people_avatar"
          v-if="item[props.avatar] && item[props.avatar] != '[]'"
        /> -->
        <div class="last_name">
          {{ item[props.label].slice(item[props.label].length - 1) }}
        </div>
        <span class="people_name">{{ item[props.label] }}</span>
        <div
          class="delete_people"
          v-if="!view && !item.isDel"
          @click="delPeople(item, index)"
        >
          <i class="el-icon-minus"></i>
        </div>
      </li>
      <li class="select_people_btn" v-if="!view" @click="addPeople">
        <i class="el-icon-plus"></i>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  inject: ["previewUrl"],
  name: "SrSelectPeople",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    props: {
      type: Object,
      default: () => {
        return {
          value: "expertId",
          label: "expertName",
          avatar: "headPhoto",
          del: "isDel",
        };
      },
    },
    view: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    addPeople() {
      this.$emit("addPeople");
    },
    delPeople(val, index) {
      this.value.splice(index, 1);
      this.$emit("delPeople");
    },
  },
};
</script>



// WEBPACK FOOTER //
// packages/SrSelectPeople/index.vue